/**
 * Kebijakan FREKUENSI resync sesi pembeli (PF-07, audit 2026-08) — dipakai
 * jalur #3 CustomerContext (visibilitychange/focus) SAJA. Jalur mount, auth
 * event (self-heal SIGNED_OUT), dan realtime TIDAK memakai kebijakan ini —
 * semantik anti-"sering terlogout" (diskriminasi error transien) tak disentuh.
 */

/** Jendela redam antar-resync jalur visibility/focus. 15 dtk = di dalam pita
 *  10–30 dtk yang diizinkan misi: cukup meredam pasangan event visible+focus
 *  & bolak-balik tab cepat, tapi kembali setelah tab lama di background
 *  (kasus yang jalur ini tangani — cookie disegarkan middleware di tab lain)
 *  tetap resync. */
export const RESYNC_MIN_INTERVAL_MS = 15_000;

/**
 * Halaman yang resync sesi STORE-nya disenyapkan: panel admin & platform.
 * Nol konsumen `useCustomer` di sana (grep 2026-08: components/admin|platform
 * kosong; BottomNav/PopupDisplay sudah self no-op). Prefix presisi cermin
 * `scopeForPath` (scope.ts) — `/administrasi` hipotetis TIDAK ikut match.
 * `/toko` SENGAJA tidak disenyapkan: ProductDetail mode katalog membaca
 * `useCustomer().isAuthenticated` (tombol Order via WA tamu).
 */
export function isResyncSuppressedPath(pathname: string): boolean {
  return (
    pathname === "/admin" ||
    pathname.startsWith("/admin/") ||
    pathname === "/platform" ||
    pathname.startsWith("/platform/")
  );
}

/** true = masih di dalam jendela redam → lewati resync. Stempel `lastResyncAt`
 *  hanya digeser pemanggil saat resolusi BENAR-BENAR dijalankan — event yang
 *  tersaring guard tidak menggesernya (bolak-balik tab cepat tak boleh
 *  menunda resync selamanya). Jam dinding yang MELOMPAT MUNDUR (koreksi
 *  NTP/HP) membuat `now < lastResyncAt` — itu BUKAN alasan meredam: tanpa
 *  guard ini redamannya bertahan selama lompatan + jendela, melampaui pita
 *  10–30 dtk yang diizinkan (temuan review OPT-3B). */
export function shouldSkipResync(
  lastResyncAt: number,
  now: number,
  minIntervalMs: number = RESYNC_MIN_INTERVAL_MS
): boolean {
  const elapsed = now - lastResyncAt;
  return elapsed >= 0 && elapsed < minIntervalMs;
}
